/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

// Adapt subscription copy to the content page's Markdown copy block.
const formatSubscriptionTerms = (entry) => {
    if (!entry?.subscription_terms) return entry;

    return {
        ...entry,
        center_blocks: [{ copy: { copy: entry.subscription_terms } }],
    };
};

export default formatSubscriptionTerms;
